import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Label')(
  ({ theme }) =>
    css({
      fontFamily: 'default',
      background: 'transparent',
      fontSize: '14px',
      lineHeight: ['22px', '22px', '24px'],
      cursor: 'pointer',
      outline: 'none',
      margin: 'zero',
      height: 'auto',
      px: ['10px', '10px', '12px'],
      py: '6px',
      borderRadius: '3px',
      border: `${theme.borders[1]} ${theme.colors.grey[0]}`,
      minWidth: '70px',
      color: `${theme.colors.black}`,
      whiteSpace: 'normal',
      textAlign: 'center',
      bg: 'white',
      '& span': {
        verticalAlign: 'middle',
      },
      '@media (hover: hover)': {
        '&:hover': {
          color: theme.colors.white,
          bg: theme.colors.darkBlue,
          borderColor: theme.colors.darkBlue,
        },
      },
      '&:before': {
        borderRadius: '3px',
      },
      '&:focus-visible': {
        outline: `${theme.borders[3]} ${theme.colors.aodaFocused}`,
        outlineOffset: '-3px',
        borderRadius: '3px',
      },
    }),
  ({ theme, active }) =>
    active &&
    css({
      color: theme.colors.white,
      bg: theme.colors.blue,
      borderColor: theme.colors.blue,
      '@media only screen and (max-width: 992px)': {
        '&:hover': {
          color: theme.colors.white,
          bg: theme.colors.blue,
          borderRadius: '3px',
          borderColor: theme.colors.blue,
        },
      },
    }),
  ({ theme, disabled }) =>
    disabled &&
    css({
      color: theme.colors.grey[0],
      bg: theme.colors.grey[3],
      borderColor: theme.colors.grey[3],
      '&:hover': {
        color: theme.colors.grey[0],
        bg: theme.colors.grey[3],
        borderColor: theme.colors.grey[3],
        pointerEvents: 'none',
      },
      '&hover > span': {
        pointerEvents: 'none',
      },
    }),
);
themeStyles.addBaseStyles('HiddenInput')(
  css({
    display: 'none',
    position: 'absolute',
  }),
);

themeStyles.addBaseStyles('CheckmarkIcon')(
  css({
    mr: 'xs',
  }),
);

export default themeStyles;
